import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const LandingPageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  animation: ${fadeIn} 0.3s ease-in;
`;

export const LandingPageContent = styled.div`
  max-width: 720px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  text-align: center;
  padding: 2rem 0;

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    padding: 1.5rem 0;
    gap: 1.25rem;
  }
`;

export const Logo = styled.img`
  height: 5rem;
  width: auto;

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    height: 3.5rem;
  }
`;

export const LandingPageTitle = styled.h1`
  font-size: ${(props) => props.theme.fontSizeTitle};
  color: ${(props) => props.theme.titleColor};
  margin: 0;

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    font-size: ${(props) => props.theme.fontSizeMobileTitle};
  }
`;

export const LandingPageDescription = styled.p`
  font-size: ${(props) => props.theme.fontSizeMd};
  color: ${(props) => props.theme.secondaryColor};
  line-height: 1.7;
  margin: 0;

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    font-size: ${(props) => props.theme.fontSizeBase};
  }
`;

export const MainButton = styled.button`
  background-color: ${(props) => props.theme.buttonBg};
  color: ${(props) => props.theme.white};
  border: none;
  padding: 0.75rem 2.5rem;
  cursor: pointer;
  font-size: ${(props) => props.theme.fontSizeLg};
  font-weight: 600;
  transition: background-color 0.125s ease-in;

  &:hover {
    background-color: ${(props) => props.theme.buttonBgHover};
  }
`;

export const DataNotice = styled.p`
  font-size: ${(props) => props.theme.fontSizeXs};
  color: ${(props) => props.theme.grayDark};
  line-height: 1.5;
  font-style: italic;
  margin: 0;
  max-width: 600px;

  a {
    color: ${(props) => props.theme.secondaryColor};
  }
`;
